import React, {PureComponent} from 'react';
import InputMask from 'react-input-mask';


export default class PhoneInput extends PureComponent {
  render() {
    const {value, onChange, label} = this.props;

    return (
      <InputMask mask="999-999-9999" placeholder={label} value={value} onChange={event => onChange(event.target.value || null)} type='tel' />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PhoneInput.js